export default __webpack_public_path__ + "static/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917-8c4986ee4828b47d16f5cd694ef065f2.svg";